import _getBuiltIn from "../internals/get-built-in";
import _isCallable from "../internals/is-callable";
import _objectIsPrototypeOf from "../internals/object-is-prototype-of";
import _useSymbolAsUid from "../internals/use-symbol-as-uid";
var exports = {};
var getBuiltIn = _getBuiltIn;
var isCallable = _isCallable;
var isPrototypeOf = _objectIsPrototypeOf;
var USE_SYMBOL_AS_UID = _useSymbolAsUid;
var $Object = Object;
exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == "symbol";
} : function (it) {
  var $Symbol = getBuiltIn("Symbol");
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};
export default exports;